import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteConfig } from '@/mocks/siteConfig';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="fa-solid fa-magnet text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-900">磁力网站大全</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {siteConfig.description}
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-900 mb-4">快速导航</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">首页</Link>
              <Link to="/about" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">关于我们</Link>
              <Link to="/category/yingshi" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">影视资源</Link>
              <Link to="/category/ruanjian" className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors">软件工具</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-900 mb-4">资源分类</h4>
            <div className="space-y-2">
              {categories.slice(0, 6).map(cat => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="block text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-900 mb-4">联系我们</h4>
            <div className="space-y-3 text-sm text-foreground-600">
              <p>邮箱：{siteConfig.contact.email}</p>
              <p>微信：{siteConfig.contact.wechat}</p>
              <p>QQ群：{siteConfig.contact.qq}</p>
              <div className="flex gap-3 mt-3">
                <a href="#" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors" aria-label="邮箱">
                  <i className="ri-mail-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteConfig.name} · 版权所有
          </p>
          <div className="flex flex-wrap gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-foreground-700 transition-colors">免责声明</a>
            <a href="#" className="hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-foreground-700 transition-colors">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}